/**
 * Familux i18n overlay — applied via i18n.addResourceBundle(deep=true, overwrite=true),
 * without changing the default locales schema.
 *
 * Extension: add further languages / keys here, the default stays
 * untouched. Consumed exclusively in `tenants/familux/index.ts`.
 */
export const familuxTranslations: Record<string, Record<string, unknown>> = {
  de: {
    booking: {
      package_other: 'Aktionswochen',
      packageOffer: 'Aktionswochen',
    },
  },
  en: {
    booking: {
      package_other: 'Special Weeks',
      packageOffer: 'Special Weeks',
    },
  },
};
